import { render, staticRenderFns } from "./MiddlemanDetail.vue?vue&type=template&id=24155602&"
import script from "./MiddlemanDetail.vue?vue&type=script&lang=js&"
export * from "./MiddlemanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports